import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const walmartRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Walmart" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { WalmartCallback } = await import("./callback");
          return { Component: WalmartCallback };
        },
      },
    ],
  },
];
